import { Component, OnInit } from '@angular/core';
import { DestroyBase } from '../ng-destroy-base';
import { EventBusService } from '../../../services/event-bus.service';

/**
 * Loading indicator component that can be controlled via the event bus
 */
@Component({
  selector: 'data-loader',
  templateUrl: './data-loader.component.html'
})
export class DataLoaderComponent extends DestroyBase implements OnInit {
  /**
   * Display the loading indicator?
   */
  public displayLoader = false;

  /**
   * Constructor
   * @param eventBus EventBusService
   */
  constructor(private eventBus: EventBusService) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.onEvents.push(this.eventBus.subscribeEvent('dataLoader', (config, _options) => {
      this.displayLoader = config.displayLoader();
    }));
  }
}
